import React, { useState, useEffect } from "react";
import "../../assets/styles/local/WorkflowAutomation.css";
import { Row, Col } from "react-bootstrap";
import AppDatePicker from "../Common/AppDatePicker";
import Calendericon from "../../assets/icons/Calendar with interaction.svg";
import DateSelector from "./DateSelector";
import ActionAssignmentModel from "./ActionAssignmentModel";
import plusCircle from "../../assets/icons/plusCircle.svg";

import { useDispatch, useSelector } from "react-redux";
import AssigneeModal from "../TaskFilter/AssigneeModal";
import {
  FetchTaskStatus,
  FetchTaskList,
} from "../../redux/actions/workflowAutomationActions";
import WorkflowChecklist from "./WorkflowChecklist";

const ActionWorkflow = ({ applyAction }) => {
  // Module Dropdown Binding
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions
  );

  const [moduleOptions, setModuleOption] = useState([
    {
      label: "Select Module",
      value: "",
      disabel: true,
    },
  ]);

  useEffect(() => {
    let moduleList = getAppSideNavOptions.map((o) => {
      return {
        label: o.modulename,
        value: o.moduleid,
        disabel: false,
      };
    });
    setModuleOption([...moduleOptions, ...moduleList]);
  }, [getAppSideNavOptions]);

  // Action Dropdown binding
  const actionsList = useSelector((state) => state.user.workflowActions);

  const [actionOptions, setActionOptions] = useState([
    {
      label: "Select Action",
      value: "",
      disabel: true,
    },
  ]);

  const [taskList, setTaskList] = useState([
    {
      label: "Select Task",
      value: "",
      disabel: true,
    },
  ]);

  useEffect(() => {
    let _actionsList = actionsList.data.map((o) => {
      return {
        label: o.actionName,
        value: o.actionId,
        disabel: false,
      };
    });
    setActionOptions([...actionOptions, ..._actionsList]);
  }, [actionsList]);

  const taskTypeList = useSelector((state) => state.user.workflowTaskType);

  const [taskTitleOption, setTaskTitleOption] = useState([
    {
      label: "Select type of task",
      value: "",
      disabel: true,
    },
  ]);

  const [taskStatusOption, setTaskStatusOption] = useState([
    {
      label: "Select status of task",
      value: "",
      disabel: true,
    },
  ]);

  const taskStatusList = useSelector(
    (state) => state.user.workflowTaskStatusList
  );
  const companytaskList = useSelector((state) => state.user.workflowTaskList);
  useEffect(() => {
    let _taskList = companytaskList.data.map((o) => {
      return {
        label: o.taskname,
        value: o.taskid,
        disabel: false,
      };
    });
    setTaskList([
      {
        label: "Select Task",
        value: "",
        disabel: true,
      },
      ..._taskList,
    ]);
  }, [companytaskList]);

  useEffect(() => {
    let _taskStatusList = taskStatusList.data.map((o) => {
      return {
        label: o.statusname,
        value: o.statusid,
        disabel: false,
      };
    });
    setTaskStatusOption([
      {
        label: "Select new status",
        value: "",
        disabel: true,
      },
      ..._taskStatusList,
    ]);
  }, [taskStatusList]);

  useEffect(() => {
    let _taskTypeList = taskTypeList.data.map((o) => {
      return {
        label: o.label,
        value: o.value,
        disabel: false,
      };
    });
    setTaskTitleOption([...taskTitleOption, ..._taskTypeList]);
  }, [taskTypeList]);

  const [moduleId, setModuleId] = useState("");
  const [actionId, setActionId] = useState("");
  const [actionIdName, setActionIdName] = useState("");
  const [taskId, setTaskId] = useState("");
  const [actionTitle, setActionTitle] = useState("");
  const [taskStatus, setTaskStatus] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [startDateCount, setStartDateCount] = useState(0);
  const [endDateCount, setEndDateCount] = useState(0);
  const [openAssignmentPopup, setOpenAssignmentPopup] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const onApplyClick = () => {
    const _module = moduleOptions.find((o) => o.value === moduleId);
    const _action = actionOptions.find((o) => o.value === actionId);

    applyAction({
      moduleId: moduleId,
      moduleName: _module.label,
      actionId: actionId,
      actionName: _action.label,
      actionTitle: actionTitle,
      actionDescription: description,
      startdate: startDate,
      enddate: endDate,
      taskStatus: taskStatus,
      workFlowactionassignee: selectedUsers.map((o) => {
        return { assigneeid: o.assigneeid, type: o.type };
      }),
      startDateCount: startDateCount,
      endDateCount: endDateCount,
      taskId: taskId,
      workflowChecklist: checklist,
    });
  };

  const onUpdateAssignee = (data) => {
    setSelectedUsers([...data]);
  };

  const getNameInitials = (user) => {
    let initials = "";
    if (user.firstname) {
      initials = user.firstname[0];
    }

    if (user.lastname) {
      initials = initials + user.lastname[0];
    }

    return initials.toUpperCase();
  };

  const [checklist, setChecklist] = useState([]);

  const addNewChecklist = (checlistDiscription) => {
    let newChecklist = [...checklist];
    newChecklist.push(checlistDiscription);
    setChecklist(newChecklist);

    console.log(checklist);
  };

  const updateChecklist = (indexToRemove) => {
    setChecklist((prevItems) =>
      prevItems.filter((_, index) => index !== indexToRemove)
    );
  };

  return (
    <>
      {/* input form section */}
      <div className="width-35-vw  min-height-25vh mb-4">
        {/* Module Selection  */}
        <div className="workflow_input_wrap mt-4" style={{ marginBottom: 0 }}>
          <label className="workflow_form_label">Module</label>
          <div className="input_wrap">
            <select
              className="cursor-pointer"
              value={moduleId}
              onChange={(e) => {
                setModuleId(e.target.value);
              }}
            >
              {moduleOptions.length &&
                moduleOptions.map((o) => (
                  <option
                    value={o.value}
                    disabled={o.disabel}
                    selected={o.disabel}
                    hidden={o.disabel}
                  >
                    {o.label}
                  </option>
                ))}
            </select>
          </div>
        </div>

        {/* Action Selection  */}
        {moduleId === "08da4e8a-6050-40db-8d54-5751dc976033" && (
          <div className="workflow_input_wrap mt-4" style={{ marginBottom: 0 }}>
            <label className="workflow_form_label">Action</label>
            <div className="input_wrap">
              <select
                className="cursor-pointer"
                value={actionId}
                onChange={(e) => {
                  setActionId(e.target.value);
                  setActionIdName(e.target.value);
                }}
              >
                {actionOptions.length &&
                  actionOptions.map((o) => (
                    <option
                      value={o.value}
                      disabled={o.disabel}
                      selected={o.disabel}
                      hidden={o.disabel}
                    >
                      {o.label}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        )}

        {/* Task Title Section */}
        {/* {actionId === "Create Task" && "asc"} */}
        {actionId === "08a15c34-4451-4df8-b14b-7f5bd41c2501" && (
          <sectionOPT>
            <div
              className="workflow_input_wrap mt-4"
              style={{ marginBottom: 0 }}
            >
              <label className="workflow_form_label">Task Title</label>
              <div className="input_wrap">
                {/* <select
                  className="cursor-pointer"
                  value={actionTitle}
                  onChange={(e) => {
                    setActionTitle(e.target.value);
                  }}
                >
                  {taskTitleOption.length &&
                    taskTitleOption.map((o) => (
                      <option
                        value={o.value}
                        disabled={o.disabel}
                        selected={o.disabel}
                        hidden={o.disabel}
                      >
                        {o.label}
                      </option>
                    ))}
                </select> */}

                <input
                  type="text"
                  placeholder="Task Title"
                  value={actionTitle}
                  onChange={(e) => setActionTitle(e.target.value)}
                  style={{ fontSize: "15px" }}
                />
              </div>
            </div>

            {/* Task Description */}
            <div
              className="workflow_input_wrap mt-4"
              style={{ marginBottom: 0 }}
            >
              <label className="workflow_form_label">Task description</label>
              <div className="input_wrap">
                <textarea
                  placeholder="Add a description"
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  style={{ fontSize: "14px" }}
                />
              </div>
            </div>

            <WorkflowChecklist
              checklist={checklist}
              addNewChecklist={addNewChecklist}
              removeChecklist={updateChecklist}
            />

            <Row>
              {/* Start Date */}
              <Col>
                <div
                  className="workflow_input_wrap mt-4 cursor-pointer"
                  style={{ marginBottom: 0 }}
                >
                  <label className="workflow_form_label">Start Date</label>
                  <div className="input_wrap">
                    <DateSelector
                      value={startDateCount}
                      onChange={setStartDateCount}
                      displayLabel={"Today"}
                    />
                  </div>
                </div>
              </Col>

              {/* End Date */}
              <Col>
                <div
                  className="workflow_input_wrap mt-4"
                  style={{ marginBottom: 0 }}
                >
                  <label className="workflow_form_label">End Date</label>
                  <div className="input_wrap">
                    <DateSelector
                      value={endDateCount}
                      onChange={setEndDateCount}
                      displayLabel={"Start Date"}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            {/* Assignment  */}
            <div
              className="workflow_input_wrap mt-4"
              style={{ marginBottom: 0 }}
            >
              <label className="workflow_form_label">Assign to</label>
              <div className="input_wrap">
                <div
                  className="date-selector-calender-icon cursor-pointer"
                  onClick={() => {
                    setOpenAssignmentPopup(!openAssignmentPopup);
                  }}
                >
                  {selectedUsers &&
                    selectedUsers.length > 0 &&
                    selectedUsers.map((o) => {
                      return (
                        <>
                          {o.imageurl ? (
                            <img
                              className=" circle-image"
                              src={o.imageurl}
                              alt="assign"
                            />
                          ) : (
                            <div className="circle-initials">
                              {getNameInitials(o)}
                            </div>
                          )}
                        </>
                      );
                    })}

                  <img className="" src={plusCircle} alt="assign" />
                </div>

                {/* <ActionAssignmentModel /> */}

                {openAssignmentPopup && (
                  <div>
                    <AssigneeModal
                      isBuildingBlock={true}
                      modalOpen={openAssignmentPopup}
                      modalHideEv={() => setOpenAssignmentPopup(false)}
                      selectedUsers={selectedUsers}
                      setSelectedUsers={(data) => {
                        onUpdateAssignee(data);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </sectionOPT>
        )}
        {/* Change Task Status here start */}
        {actionId === "08a15c34-4451-4df8-b14b-7f5bd41c2502" && (
          <sectionOPT>
            <div
              className="workflow_input_wrap mt-4"
              style={{ marginBottom: 0 }}
            >
              <label className="workflow_form_label">Select Task</label>
              <div className="input_wrap">
                <select
                  className="cursor-pointer"
                  value={taskId}
                  onChange={(e) => {
                    setTaskId(e.target.value);
                  }}
                >
                  {taskList.length &&
                    taskList.map((o) => (
                      <option
                        value={o.value}
                        disabled={o.disabel}
                        selected={o.disabel}
                        hidden={o.disabel}
                      >
                        {o.label}
                      </option>
                    ))}
                </select>

                {/* <input
                  placeholder="Value"
                  type="text"
                  value={actionTitle}
                  onChange={(e) => setActionTitle(e.target.value)}
                  style={{ fontSize: "14px" }}
                /> */}
              </div>
            </div>

            <Row>
              <Col xl={6} lg={6} md={6} sm={12}>
                <div
                  className="workflow_input_wrap mt-4"
                  style={{ marginBottom: 0 }}
                >
                  <label className="workflow_form_label">New Status</label>
                  <div className="input_wrap">
                    <select
                      className="cursor-pointer"
                      value={taskStatus}
                      onChange={(e) => {
                        setTaskStatus(e.target.value);
                      }}
                    >
                      {taskStatusOption.length &&
                        taskStatusOption.map((o) => (
                          <option
                            value={o.value}
                            disabled={o.disabel}
                            selected={o.disabel}
                            hidden={o.disabel}
                          >
                            {o.label}
                          </option>
                        ))}
                    </select>

                    {/* <input
                  placeholder="Value"
                  type="text"
                  value={actionTitle}
                  onChange={(e) => setActionTitle(e.target.value)}
                  style={{ fontSize: "14px" }}
                /> */}
                  </div>
                </div>
              </Col>

              {/* Start Date */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <div
                  className="workflow_input_wrap mt-4 cursor-pointer"
                  style={{ marginBottom: 0 }}
                >
                  <label className="workflow_form_label">When?</label>
                  <div className="input_wrap">
                    <DateSelector
                      value={startDateCount}
                      onChange={setStartDateCount}
                      displayLabel={"Today"}
                    />
                  </div>
                </div>
              </Col>

              {/* End Date */}
              {/* <Col>
                <div
                  className="workflow_input_wrap mt-4"
                  style={{ marginBottom: 0 }}
                >
                  <label className="workflow_form_label">End Date</label>
                  <div className="input_wrap">
                    <DateSelector
                      value={endDateCount}
                      onChange={setEndDateCount}
                      displayLabel={"Start Date"}
                    />
                  </div>
                </div>
              </Col> */}
            </Row>

            {/* Assignment  */}
            <div
              className="workflow_input_wrap mt-4 d-none"
              style={{ marginBottom: 0 }}
            >
              <label className="workflow_form_label">Assign to</label>
              <div className="input_wrap">
                <div
                  className="date-selector-calender-icon cursor-pointer"
                  onClick={() => {
                    setOpenAssignmentPopup(!openAssignmentPopup);
                  }}
                >
                  {selectedUsers &&
                    selectedUsers.length > 0 &&
                    selectedUsers.map((o) => {
                      return (
                        <>
                          {o.imageurl ? (
                            <img
                              className=" circle-image"
                              src={o.imageurl}
                              alt="assign"
                            />
                          ) : (
                            <div className="circle-initials">
                              {getNameInitials(o)}
                            </div>
                          )}
                        </>
                      );
                    })}

                  <img className="" src={plusCircle} alt="assign" />
                </div>

                {/* <ActionAssignmentModel /> */}

                {openAssignmentPopup && (
                  <div>
                    <AssigneeModal
                      isBuildingBlock={true}
                      modalOpen={openAssignmentPopup}
                      modalHideEv={() => setOpenAssignmentPopup(false)}
                      selectedUsers={selectedUsers}
                      setSelectedUsers={(data) => {
                        onUpdateAssignee(data);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </sectionOPT>
        )}
        {/* Change Task Status here end */}

        {/* Delete Task here start */}
        {actionId === "08a15c34-4451-4df8-b14b-7f5bd41c2503" && (
          <sectionOPT>
            <div
              className="workflow_input_wrap mt-4"
              style={{ marginBottom: 0 }}
            >
              <label className="workflow_form_label">Select Task</label>
              <div className="input_wrap">
                <select
                  className="cursor-pointer"
                  value={taskId}
                  onChange={(e) => {
                    setTaskId(e.target.value);
                  }}
                >
                  {taskList.length &&
                    taskList.map((o) => (
                      <option
                        value={o.value}
                        disabled={o.disabel}
                        selected={o.disabel}
                        hidden={o.disabel}
                      >
                        {o.label}
                      </option>
                    ))}
                </select>

                {/* <input
                  placeholder="Value"
                  type="text"
                  value={actionTitle}
                  onChange={(e) => setActionTitle(e.target.value)}
                  style={{ fontSize: "14px" }}
                /> */}
              </div>
            </div>

            {/* Task Description */}
            {/* <div
              className="workflow_input_wrap mt-4"
              style={{ marginBottom: 0 }}
            >
              <label className="workflow_form_label">Task description</label>
              <div className="input_wrap">
                <textarea
                  placeholder="Add a description"
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  style={{ fontSize: "14px" }}
                />
              </div>
            </div> */}

            <Row>
              {/* Start Date */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <div
                  className="workflow_input_wrap mt-4 cursor-pointer"
                  style={{ marginBottom: 0 }}
                >
                  <label className="workflow_form_label">When?</label>
                  <div className="input_wrap">
                    <DateSelector
                      value={startDateCount}
                      onChange={setStartDateCount}
                      displayLabel={"Today"}
                    />
                  </div>
                </div>
              </Col>

              {/* End Date */}
              {/* <Col>
                <div
                  className="workflow_input_wrap mt-4"
                  style={{ marginBottom: 0 }}
                >
                  <label className="workflow_form_label">End Date</label>
                  <div className="input_wrap">
                    <DateSelector
                      value={endDateCount}
                      onChange={setEndDateCount}
                      displayLabel={"Start Date"}
                    />
                  </div>
                </div>
              </Col> */}
            </Row>

            {/* Assignment  */}
            <div
              className="workflow_input_wrap mt-4 d-none"
              style={{ marginBottom: 0 }}
            >
              <label className="workflow_form_label">Assign to</label>
              <div className="input_wrap">
                <div
                  className="date-selector-calender-icon cursor-pointer"
                  onClick={() => {
                    setOpenAssignmentPopup(!openAssignmentPopup);
                  }}
                >
                  {selectedUsers &&
                    selectedUsers.length > 0 &&
                    selectedUsers.map((o) => {
                      return (
                        <>
                          {o.imageurl ? (
                            <img
                              className=" circle-image"
                              src={o.imageurl}
                              alt="assign"
                            />
                          ) : (
                            <div className="circle-initials">
                              {getNameInitials(o)}
                            </div>
                          )}
                        </>
                      );
                    })}

                  <img className="" src={plusCircle} alt="assign" />
                </div>

                {/* <ActionAssignmentModel /> */}

                {openAssignmentPopup && (
                  <div>
                    <AssigneeModal
                      isBuildingBlock={true}
                      modalOpen={openAssignmentPopup}
                      modalHideEv={() => setOpenAssignmentPopup(false)}
                      selectedUsers={selectedUsers}
                      setSelectedUsers={(data) => {
                        onUpdateAssignee(data);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </sectionOPT>
        )}
        {/* Delete Task here end */}
      </div>

      {/* Actions section   */}
      <div className="width-35-vw d-flex justify-content-center">
        <div className="apply-btn" onClick={onApplyClick}>
          Apply
        </div>
      </div>
    </>
  );
};

export default ActionWorkflow;
